<script setup lang="ts">
import MultiautocompleteField from '@/components/Selector/MultiautocompleteField.vue'
import roleApi from '@/services/role.service'
import type { SelectorObject } from '@/types/components/SelectorObject'
import type { RoleModel } from '@/types/models/RoleModel'
import { computed, onMounted, ref } from 'vue'

const rolesOptions = ref<RoleModel[]>([])

const props = defineProps<{ roles: string[]; guard_name?: string }>()
const emit = defineEmits<{ (e: 'change', roles: SelectorObject[]): void }>()

onMounted(() => {
    roleApi
        .getRoles(props.guard_name ? { filters: { guard_name: props.guard_name } } : undefined)
        .then(res => (rolesOptions.value = res.data.map(item => ({ ...item, value: item.id }))))
})

const rolesSelected = computed(() =>
    rolesOptions.value.length
        ? props.roles.reduce((prev: RoleModel[], current) => {
              const found = rolesOptions.value.find(option => option.name === current)
              return found ? [...prev, found] : prev
          }, [])
        : []
)

const handleSelect = (value: SelectorObject[]) => emit('change', value)
</script>

<template>
    <MultiautocompleteField
        :options="rolesOptions"
        :modelValue="rolesSelected"
        @change="handleSelect"
        :label="$t('user.detail.rolesTitle')"
        class="background-color-mute" />
</template>
